import $ from 'jquery'

(window as any).jQuery = $;
(window as any).$ = $;

export default $
